import { render, staticRenderFns } from "./CheckboxCell.vue?vue&type=template&id=72d1b622&"
import script from "./CheckboxCell.vue?vue&type=script&lang=js&"
export * from "./CheckboxCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VSimpleCheckbox})
